import React from 'react';
import { PropTypes } from 'prop-types';
import OrderStop from 'components/orders/OrderStop';
import OrderStopContextProvider from 'components/orders/OrderStop/UseOrderStop';
import DriverStatus from 'components/orders/DriverStatus';

const ModalSummary = ({ className, order }) => {
  const firstStop = order.stops[0];

  return (
    <ul className={className} data-testid="modal-summary">
      <DriverStatus order={order} />
      {order.stops?.map((stop, index) => (
        <OrderStopContextProvider
          key={index}
          order={order}
          stop={stop}
          firstStop={firstStop}
          orderStatus={order.status}
          isRecurring={false}
          isLastStop={index < order.stops.length - 1}
        >
          <OrderStop
            stops={order.stops}
            stopIndex={index}
            isMultiRoute={order.stops.length >= 3}
            orderType={order.journey_type}
          />
        </OrderStopContextProvider>
      ))}
    </ul>
  );
};

ModalSummary.propTypes = {
  order: PropTypes.object.isRequired,
};

export default ModalSummary;
